// src/components/Layout/Header.js
import React, { useState, useEffect } from 'react';
import { Navbar, Container, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import Gravatar from 'react-gravatar';
import NotificationService from '../../services/NotificationService';
import { useToastStore } from '../../components/UI/Toast';
import { useSidebar } from '../../App';

const Header = () => {
    const { user, logout } = useAuthStore();
    const [darkMode, setDarkMode] = useState(localStorage.getItem('darkMode') === 'true');
    const [unreadNotifications, setUnreadNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);

    // Použití kontextu sidebaru
    const { collapsed, setCollapsed } = useSidebar();

    const addToast = useToastStore(state => state.addToast);

    // Efekt pro tmavý režim
    useEffect(() => {
        if (darkMode) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
        localStorage.setItem('darkMode', darkMode);
    }, [darkMode]);

    // Načtení nepřečtených notifikací při načtení komponenty
    useEffect(() => {
        if (user) {
            /*fetchUnreadNotifications();
            const intervalId = setInterval(fetchUnreadCount, 60000); // Každou minutu aktualizujeme počet

            // Přihlásíme se k odběru real-time notifikací
            const unsubscribe = NotificationService.subscribeToRealTimeNotifications(handleNewNotification);

            return () => {
                clearInterval(intervalId);
                unsubscribe();
            };*/
        }
    }, [user]);

    // Načtení nepřečtených notifikací
    const fetchUnreadNotifications = async () => {
        if (!user) return;

        setIsLoadingNotifications(true);
        try {
            const notifications = await NotificationService.getUnreadNotifications(5);
            setUnreadNotifications(notifications);
            setUnreadCount(notifications.length);
        } catch (error) {
            console.error('Failed to fetch unread notifications:', error);
        } finally {
            setIsLoadingNotifications(false);
        }
    };

    // Načtení počtu nepřečtených notifikací
    const fetchUnreadCount = async () => {
        if (!user) return;

        try {
            const count = await NotificationService.getUnreadCount();
            setUnreadCount(count);
        } catch (error) {
            console.error('Failed to fetch unread count:', error);
        }
    };

    // Zpracování nové notifikace
    const handleNewNotification = (notification) => {
        // Přidáme notifikaci do seznamu nepřečtených
        setUnreadNotifications(prev => [notification, ...prev.slice(0, 4)]);
        setUnreadCount(prev => prev + 1);

        // Zobrazíme toast s notifikací
        addToast(notification.message, notification.type === 'error' ? 'danger' : 'info');
    };

    // Označení notifikace jako přečtené
    const markAsRead = async (notificationId) => {
        try {
            await NotificationService.markAsRead(notificationId);
            setUnreadNotifications(prev => prev.filter(n => n.id !== notificationId));
            setUnreadCount(prev => Math.max(0, prev - 1));
        } catch (error) {
            console.error('Failed to mark notification as read:', error);
        }
    };

    // Označení všech notifikací jako přečtených
    const markAllAsRead = async () => {
        try {
            await NotificationService.markAllAsRead();
            setUnreadNotifications([]);
            setUnreadCount(0);
        } catch (error) {
            console.error('Failed to mark all notifications as read:', error);
        }
    };

    const toggleDarkMode = () => {
        setDarkMode(!darkMode);
    };

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

    // Získání ikony a barvy podle typu notifikace
    const getNotificationIcon = (type) => {
        switch (type) {
            case 'uptime':
                return <i className="fas fa-exclamation-circle text-danger"></i>;
            case 'security':
                return <i className="fas fa-shield-alt text-warning"></i>;
            case 'update':
                return <i className="fas fa-sync-alt text-info"></i>;
            default:
                return <i className="fas fa-bell text-secondary"></i>;
        }
    };

    return (
        <Navbar expand="lg" className="app-header">
            <Container fluid>
                <button
                    className="menu-toggle"
                    onClick={toggleSidebar}
                    title={collapsed ? "Rozbalit menu" : "Sbalit menu"}
                >
                    <i className={`fas ${collapsed ? 'fa-bars' : 'fa-times'}`}></i>
                </button>

                <div className="d-flex align-items-center ms-auto">
                    {/* Theme Selector
                    <div className="me-3">
                        <ThemeSelector />
                    </div> */}

                    {/* Dark Mode Toggle
                    <button
                        className="btn-icon me-3"
                        onClick={toggleDarkMode}
                        title={darkMode ? "Přepnout na světlý režim" : "Přepnout na tmavý režim"}
                    >
                        <i className={`fas ${darkMode ? 'fa-sun' : 'fa-moon'}`}></i>
                    </button> */}
                    {/* Notifications */}
                    {user && false && (
                        <Dropdown align="end" className="me-3">
                            <Dropdown.Toggle as="div" className="notification-toggle position-relative cursor-pointer">
                                <i className="fas fa-bell fs-5"></i>
                                {unreadCount > 0 && (
                                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                        {unreadCount > 99 ? '99+' : unreadCount}
                                    </span>
                                )}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu-end shadow-sm notification-dropdown" style={{ minWidth: '320px' }}>
                                <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                                    <h6 className="mb-0">Oznámení</h6>
                                    {unreadCount > 0 && (
                                        <button
                                            className="btn btn-link btn-sm text-decoration-none"
                                            onClick={markAllAsRead}
                                        >
                                            Označit vše jako přečtené
                                        </button>
                                    )}
                                </div>

                                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    {isLoadingNotifications ? (
                                        <div className="text-center p-3">
                                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                <span className="visually-hidden">Načítání...</span>
                                            </div>
                                        </div>
                                    ) : unreadNotifications.length === 0 ? (
                                        <div className="text-center text-muted p-3">
                                            <i className="fas fa-bell-slash mb-2 fs-4"></i>
                                            <p className="mb-0">Žádná nová oznámení</p>
                                        </div>
                                    ) : (
                                        unreadNotifications.map(notification => (
                                            <Dropdown.Item
                                                key={notification.id}
                                                className="border-bottom notification-item"
                                                onClick={() => markAsRead(notification.id)}
                                            >
                                                <div className="d-flex">
                                                    <div className="me-3">
                                                        {getNotificationIcon(notification.type)}
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <p className="mb-1">{notification.message}</p>
                                                        <small className="text-muted">
                                                            {new Date(notification.createdAt).toLocaleString()}
                                                        </small>
                                                    </div>
                                                </div>
                                            </Dropdown.Item>
                                        ))
                                    )}
                                </div>

                                <div className="text-center p-2 border-top">
                                    <Link to="/notifications" className="btn btn-link btn-sm text-decoration-none">
                                        Zobrazit všechna oznámení
                                    </Link>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    )}

                    {/* User Menu */}
                    {user ? (
                        <Dropdown align="end">
                            <Dropdown.Toggle as="div" className="user-dropdown d-flex align-items-center">
                                    <Gravatar className="avatar-circle avatar-sm me-2"
                                              email={user.email} size={100} rating="pg" default="monsterid"
                                              />
                                <span className="d-none d-md-inline">{user.firstName} {user.lastName || user.email}</span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to="/profile">
                                    <i className="fas fa-user me-2"></i> Profil
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/subscription">
                                    <i className="fas fa-credit-card me-2"></i> Předplatné
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/credits">
                                    <i className="fas fa-coins me-2"></i> Kredity
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item onClick={logout}>
                                    <i className="fas fa-sign-out-alt me-2"></i> Odhlásit
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    ) : (
                        <div>
                            <Link to="/login" className="btn btn-outline-primary me-2">Přihlásit</Link>
                            <Link to="/register" className="btn btn-primary">Registrovat</Link>
                        </div>
                    )}
                </div>
            </Container>
        </Navbar>
    );
};

export default Header;